module.exports = __webpack_public_path__ + "static/media/park.c1dc28be.png";